<template>
    <div >
        <vs-input class="w-3/12" v-model="fromCompanyId" label="Da empresa" />
        <vs-input class="w-3/12" v-model="toCompanyId" label="Para empresa" />
        <vs-button class="mt-4" @click="copy" > Copiar </vs-button>
    </div>
</template>

<script>
    import { copyFromCollection, 
             pasteToCollection } from './copy.js'

    export default {
        data () {
            return {
                fromCompanyId : '',
                toCompanyId : ''
            }
        },

        methods : {
            copy () {
                const { fromCompanyId, toCompanyId } = this

                this.copyFromCollection(fromCompanyId, toCompanyId, 'productInOption')
                this.copyFromCollection(fromCompanyId, toCompanyId, 'productType')
                this.copyFromCollection(fromCompanyId, toCompanyId, 'products')
                this.copyFromCollection(fromCompanyId, toCompanyId, 'menu')
                this.copyFromCollection(fromCompanyId, toCompanyId, 'productOptions')
                this.copyFromCollection(fromCompanyId, toCompanyId, 'counters')
                this.copyFromCollection(fromCompanyId, toCompanyId, 'bill')
            },

            async copyFromCollection (fromCompanyId, toCompanyId, collection) {
                let objOptionIn  = await copyFromCollection(fromCompanyId, collection);
                let pasteOptionsInFrom = await pasteToCollection(toCompanyId, collection, objOptionIn);
                if(!pasteOptionsInFrom) {
                    console.info(`${collection} => Sucesso`)
                } else {
                    console.error(`${collection} =>`, pasteOptionsInFrom)
                }
            }
        }
    }
</script>